import { gsap } from 'gsap';

const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  const modal = document.querySelector('.disclaimer-download-modal');
  const disclaimerDownloadButtons = document.querySelectorAll(
    '.deepsea-row--show-disclaimer-download',
  );

  if (modal === null || disclaimerDownloadButtons.length === 0) {
    return;
  }

  const showDisclaimer = () => {
    gsap.set(modal, { autoAlpha: 0, display: 'none' });
    gsap.to(modal, { duration: 0.3, autoAlpha: 1, display: 'block' });
  };

  const closeDisclaimer = () => {
    gsap.to(modal, { duration: 0.3, autoAlpha: 0, display: 'none' });
  };

  const handleDownload = (e) => {
    const { target } = e;

    if (target.getAttribute('data-new-tab') === 'true') {
      window.open(target.getAttribute('data-download-url'), '_blank');
    } else {
      window.location.href = target.getAttribute('data-download-url');
    }

    closeDisclaimer();
  };

  const confirmButton = modal.querySelector('.confirm-button');
  const declineButton = modal.querySelector('.decline-button');

  confirmButton.addEventListener('click', handleDownload);
  declineButton.addEventListener('click', closeDisclaimer);

  Array.from(disclaimerDownloadButtons).forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const downloadUrl = e.currentTarget.href;
      const newTab = e.currentTarget.getAttribute('target') === '_blank';

      confirmButton.setAttribute('data-download-url', downloadUrl);
      if (newTab) {
        confirmButton.setAttribute('data-new-tab', 'true');
      }

      showDisclaimer();
    });
  });
});
